'use client';
import { createContext, useEffect } from 'react';
import { useNonNullishContext } from '../../../hooks/use-non-nullish-context.js';

const SwanCollectionContext = createContext(void 0);
function useCollectionContext() {
    return useNonNullishContext(SwanCollectionContext);
}
function useTrackDisabledState(t, o) {
    let { setDisabledKeys: n } = useCollectionContext();
    useEffect(()=>{
        null != o && n((e)=>{
            let n = new Set(e);
            return o ? n.add(t) : n.delete(t), n;
        });
    }, [
        n,
        t,
        o
    ]);
}

export { SwanCollectionContext, useCollectionContext, useTrackDisabledState };
